import React from "react";
import { 
  TrendingUp, 
  Wallet, 
  Clock, 
  CheckCircle 
} from "lucide-react";

/**
 * Earnings Summary Cards
 * 
 * Displays key earnings metrics in a grid.
 */
export function EarningsSummaryCards({ summary, hasBankDetails }) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-px bg-border border border-border">
      <SummaryCard
        icon={TrendingUp}
        iconBg="bg-emerald-500"
        label="Total Earnings"
        value={summary.total_earnings || 0}
      />
      <SummaryCard
        icon={Wallet}
        iconBg="bg-orange-500"
        label="Available Balance"
        value={summary.available_balance || 0}
        valueClass="text-emerald-600"
        note={!hasBankDetails ? "Add bank details to withdraw" : null}
      />
      <SummaryCard
        icon={Clock}
        iconBg="bg-amber-500"
        label="Pending Withdrawal"
        value={summary.pending_withdrawal || 0}
      />
      <SummaryCard
        icon={CheckCircle}
        iconBg="bg-blue-500"
        label="Total Withdrawn"
        value={summary.total_withdrawn || 0}
      />
    </div>
  );
}

function SummaryCard({ icon: Icon, iconBg, label, value, valueClass = "", note }) {
  return (
    <div className="bg-background p-6">
      <div className="flex items-center gap-3 mb-2">
        <div className={`w-10 h-10 ${iconBg} flex items-center justify-center`}>
          <Icon className="w-5 h-5 text-white" />
        </div>
        <span className="label-text">{label}</span>
      </div>
      <p className={`text-3xl font-black ${valueClass}`}>
        ₹{value?.toLocaleString()}
      </p>
      {note && <p className="text-xs text-amber-600 mt-1">{note}</p>}
    </div>
  );
}
